import NavOption from "../NavOption";
import React, { useState, useContext, useEffect } from "react";
import AuthContext from "../../../context/AuthContext";
import chevron from "../../../../assets/chevron.svg";
import styles from "./NavMenu.module.css";
import useGroupMemberships from "../../../../hooks/useGroupMemberships";

const AuditMenu = ({ ACTIONS, dispatch, state, closeMenus }) => {
  const authCtx = useContext(AuthContext);
  const [isAdmin, setIsAdmin] = useState(false);
  const groupMemberships = useGroupMemberships();

  useEffect(() => {
    setIsAdmin(groupMemberships.isPrimary || groupMemberships.isAuditPrimary);
  }, [groupMemberships, authCtx]);

  const onClickHandler = (event) => {
    event.preventDefault();
    dispatch({ type: ACTIONS.AUDIT_MENU_TOGGLE });
  };

  const closeMenu = () => {
    closeMenus();
  };

  const chevronClass = state.auditMenuOpen
    ? styles.chevronFocused
    : styles.chevron;

  const rootButtonClass = state.auditMenuOpen
    ? styles.subtitleButtonMenuFocused
    : styles.subtitleButtonMenu;

  return (
    <>
      {isAdmin && (
        <li>
          <button className={rootButtonClass} onClick={onClickHandler}>
            Pending Audits
            <img className={chevronClass} src={chevron} alt="" />
          </button>
          {state.auditMenuOpen && (
            <ul className={styles.subMenu2}>
              <NavOption
                displayText={"Splicers"}
                navigateTo={"/auditsPendingSplicers"}
                closeParentMenu={closeMenu}
                ACTIONS={ACTIONS}
                dispatch={dispatch}
                state={state}
                closeMenus={closeMenus}
              />
            </ul>
          )}
        </li>
      )}
    </>
  );
};

export default AuditMenu;
